import { InlineIcon } from "@iconify/react";

interface AttachmentUploadingModalProps {
  isDarkMode: boolean;
}

export function AttachmentUploadingModal({ isDarkMode }: AttachmentUploadingModalProps) {
  return (
    <div className="Modal AttachmentUploadingModal">
      <div
        className={[
          "Modal__card",
          "AttachmentUploadingModal__card",
          isDarkMode ? "bg-gray-800" : "bg-white",
        ].join(" ")}
      >
        <div
          className={[
            "Modal__card__body",
            "AttachmentUploadingModal__card__body",
            "rounded",
            isDarkMode ? "bg-gray-800" : "bg-white",
            "grid",
            "grid-cols-1",
            "gap-4",
            "items-center",
            "justify-items-center",
            "p-8",
          ].join(" ")}
        >
          <div className="grid grid-cols-1 gap-2 items-center justify-items-center">
            <InlineIcon
              icon="svg-spinners:ring-resize"
              className={["text-4xl", isDarkMode ? "text-gray-300" : "text-gray-700"].join(" ")}
            />
            <p
              className={[
                "text-lg",
                "font-medium",
                isDarkMode ? "text-gray-300" : "text-gray-700",
              ].join(" ")}
            >
              Uploading attachment...
            </p>
            <p className={["text-sm", isDarkMode ? "text-gray-400" : "text-gray-500"].join(" ")}>
              Please wait while your file is being uploaded.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
